if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification && this.openedBy) cartNotification.setActiveElement(this.openedBy);
      if (this.modalContent) this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      if (!opener || !this.modalContent) return;

      const productUrl = opener.getAttribute('data-product-url');
      const spinner = opener.querySelector('.loading-overlay__spinner');
      opener.setAttribute('aria-disabled', 'true');
      opener.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      fetch(productUrl)
        .then((response) => {
          if (!response.ok) throw new Error(`Quick Add request failed: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement) throw new Error('Quick Add product section was not found.');

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .catch((error) => {
          console.error('[JF Quick Add]', error);
          if (productUrl) window.location.assign(productUrl);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantSelect = this.modalContent.querySelector('variant-radios, variant-selects');
      if (variantSelect) variantSelect.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const removableSelectors = [
        'pickup-availability',
        'product-modal',
        '.shopify-payment-button',
        '.jf-pdp-app-rating',
        '.jf-pdp-rating',
        '.jf-pdp-subtitle',
        '.jf-pdp-note',
        '.jf-pdp-benefits',
        '.jf-pdp-trust',
        '.jf-pdp-payments',
        '.jf-pdp-pickup',
        '.jf-pdp-accordions',
        '.jf-pdp-sticky'
      ];

      removableSelectors.forEach((selector) => {
        this.productElement.querySelectorAll(selector).forEach((element) => element.remove());
      });
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      if (!sectionId) return;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;
      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach((item) => item.setAttribute('role', 'presentation'));
    }
  });
}
